export const testimonials = [
  {
    id: 1,
    name: 'Maximilian Weber',
    rating: 5,
    date: '2024-12-15',
    source: 'Google',
    text: {
      de: 'Absolut fantastisch! Die Pasta war hausgemacht und schmeckte wie in Italien. Der Service war aufmerksam aber nicht aufdringlich. Wir kommen definitiv wieder!',
      en: 'Absolutely fantastic! The pasta was homemade and tasted like in Italy. The service was attentive but not intrusive. We\'ll definitely be back!'
    },
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face'
  },
  {
    id: 2,
    name: 'Sophie Müller',
    rating: 5,
    date: '2024-12-10',
    source: 'TripAdvisor',
    text: {
      de: 'Das beste italienische Restaurant in München! Die Burrata war ein Traum und das Tiramisu hat mich an meine Reise nach Rom erinnert. Perfekt für besondere Anlässe.',
      en: 'The best Italian restaurant in Munich! The burrata was a dream and the tiramisu reminded me of my trip to Rome. Perfect for special occasions.'
    },
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face'
  },
  {
    id: 3,
    name: 'Thomas Schneider',
    rating: 5,
    date: '2024-11-28',
    source: 'Google',
    text: {
      de: 'Wir haben hier unseren Hochzeitstag gefeiert und es war perfekt. Das Ossobuco war unglaublich zart und der Wein hervorragend. Grazie mille!',
      en: 'We celebrated our anniversary here and it was perfect. The ossobuco was incredibly tender and the wine excellent. Grazie mille!'
    },
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face'
  },
  {
    id: 4,
    name: 'Elena Fischer',
    rating: 5,
    date: '2024-11-20',
    source: 'Google',
    text: {
      de: 'Das Ambiente ist wunderschön und die Pizza aus dem Steinofen einfach unschlagbar. Die Bedienung war super freundlich und hat tolle Weinempfehlungen gegeben.',
      en: 'The ambiance is beautiful and the stone oven pizza is simply unbeatable. The staff was super friendly and gave great wine recommendations.'
    },
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face'
  },
  {
    id: 5,
    name: 'Marco Bianchi',
    rating: 5,
    date: '2024-11-15',
    source: 'TripAdvisor',
    text: {
      de: 'Als Italiener bin ich sehr wählerisch, aber Bella Vista hat mich überzeugt. Die Carbonara ist authentisch und die Zutaten sind erstklassig. Complimenti!',
      en: 'As an Italian, I\'m very picky, but Bella Vista convinced me. The carbonara is authentic and the ingredients are first-class. Complimenti!'
    },
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face'
  },
  {
    id: 6,
    name: 'Anna Hoffmann',
    rating: 4,
    date: '2024-11-08',
    source: 'Google',
    text: {
      de: 'Sehr gutes Essen und angenehme Atmosphäre. Die Wartezeit war etwas lang, aber das Ergebnis hat es wett gemacht. Die Trüffel-Tagliatelle sind ein Muss!',
      en: 'Very good food and pleasant atmosphere. The waiting time was a bit long, but the result made up for it. The truffle tagliatelle is a must!'
    },
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop&crop=face'
  }
];

export const getAverageRating = () => {
  const total = testimonials.reduce((sum, t) => sum + t.rating, 0);
  return (total / testimonials.length).toFixed(1);
};

export const getTotalReviews = () => testimonials.length;
